import React from "react";

export const HomeScreen = React.lazy(() =>
    import("../screens/home/HomeScreen").then((module) => ({ default: module.HomeScreen }))
);
export const ViewCommunityPostScreen = React.lazy(() =>
    import("../screens/community/ViewCommunityPostScreen").then((module) => ({ default: module.ViewCommunityPostScreen }))
);
export const CommunityScreen = React.lazy(() =>
    import("../screens/community/CommunityScreen").then((module) => ({ default: module.CommunityScreen }))
);
export const RecipeScreen = React.lazy(() =>
    import("../screens/recipe/RecipeScreen").then((module) => ({ default: module.RecipeScreen }))
);
export const WorkoutBuilderScreen = React.lazy(() =>
    import("../screens/wobuilder/WorkoutBuilder").then((module) => ({ default: module.WorkoutBuilderScreen }))
);
export const WorkoutScreen = React.lazy(() =>
    import("../screens/workout/WorkoutScreen").then((module) => ({ default: module.WorkoutScreen }))
);
export const ViewRoutineScreen = React.lazy(() =>
    import("../screens/routine/ViewRoutineScreen").then((module) => ({ default: module.ViewRoutineScreen }))
);
export const AuthScreen = React.lazy(() =>
    import("../screens/auth/AuthScreen").then((module) => ({ default: module.AuthScreen }))
);
export const ProfileScreen = React.lazy(() =>
    import("../screens/profile/ProfileScreen").then((module) => ({ default: module.ProfileScreen }))
);
export const CreateHubScreen = React.lazy(() =>
    import("../screens/create/CreateHubScreen").then((module) => ({ default: module.CreateHubScreen }))
);
export const CreatePostScreen = React.lazy(() =>
    import("../screens/create/CreatePostScreen").then((module) => ({ default: module.CreatePostScreen }))
);
export const CreateRoutineScreen = React.lazy(() =>
    import("../screens/create/CreateRoutineScreen").then((module) => ({ default: module.CreateRoutineScreen }))
);
export const CreateRecipeScreen = React.lazy(() =>
    import("../screens/create/CreateRecipeScreen").then((module) => ({ default: module.CreateRecipeScreen }))
);

export enum Route {
    Home = "/",
    Community = "/community",
    Recipes = "/recipes",
    Recipe = "/recipes/:id",
    WorkoutBuilder = "/workoutbuilder",
    ViewCommunityPost = "/community/:id",
    ViewRoutine = "/routine/:id",
    Workout = "/workout/:id",
    WorkoutBase = "/workout/",
    Login = "/login",
    Profile = "/profile/:id",
    CreateHub = "/create",
    CreatePost = "/create/post",
    CreateRoutine = "/create/routine",
    CreateRecipe = "/create/recipe",
}

export const Routes = [
    {
        route: Route.Home,
        component: HomeScreen,
        exact: true,
    },
    {
        route: Route.Community,
        component: CommunityScreen,
        exact: true,
    },
    {
        route: Route.ViewCommunityPost,
        component: ViewCommunityPostScreen,
        exact: true,
    },
    {
        route: Route.ViewRoutine,
        component: ViewRoutineScreen,
        exact: true,
    },
    {
        route: Route.Recipe,
        component: RecipeScreen,
        exact: true,
    },
    {
        route: Route.WorkoutBuilder,
        component: WorkoutBuilderScreen,
        exact: true,
    },
    {
        route: Route.Workout,
        component: WorkoutScreen,
        exact: true,
    },
    {
        route: Route.Login,
        component: AuthScreen,
        exact: true,
    },
    {
        route: Route.Profile,
        component: ProfileScreen,
        exact: true,
    },
    {
        route: Route.CreateHub,
        component: CreateHubScreen,
        exact: true,
    },
    {
        route: Route.CreatePost,
        component: CreatePostScreen,
        exact: true,
    },
    {
        route: Route.CreateRoutine,
        component: CreateRoutineScreen,
        exact: true,
    },
    {
        route: Route.CreateRecipe,
        component: CreateRecipeScreen,
        exact: true,
    },
];
